function parseAppDate(value: string | null | undefined): Date | null {
  if (!value) return null;
  const text = String(value).trim();
  if (!text) return null;

  const sqliteUtc = text.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2})(?:\.\d+)?$/);
  const normalized = sqliteUtc ? sqliteUtc[1] + 'T' + sqliteUtc[2] + 'Z' : text;
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function timeAgo(value: string | null | undefined): string {
  const date = parseAppDate(value);
  if (!date) return '-';

  const ms = Date.now() - date.getTime();
  const sec = Math.max(0, Math.floor(ms / 1000));
  if (sec < 60) return sec + ' с назад';

  const min = Math.floor(sec / 60);
  if (min < 60) return min + ' мин назад';

  const hours = Math.floor(min / 60);
  if (hours < 24) return hours + ' ч назад';

  return Math.floor(hours / 24) + ' д назад';
}

export function formatUtc3DateTime(value: string | null | undefined): string {
  const date = parseAppDate(value);
  if (!date) return '-';

  return new Intl.DateTimeFormat('ru-RU', {
    timeZone: 'Europe/Moscow',
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date) + ' UTC+3';
}

export function formatHistoryTime(value: string | null | undefined): string {
  return formatUtc3DateTime(value) + ' · ' + timeAgo(value);
}
